export default __webpack_public_path__ + "static/media/03-Engg---Mansour-AlObaid.65addbae.png";